module.exports = __webpack_public_path__ + "img/link-banner-ru.763ad43d.png";